import { getSubdomain, getServerEndpoint } from '../../../utils/utils';

// Descarrega una plantilla com a fitxer. L'SVG es genera al backend a partir
// de l'estat actual de la plantilla (endpoint export_svg), així sempre és
// editable amb programes externs encara que la plantilla hagi canviat.
export const downloadPlantillaFile = (plantilla, type) => {
    const COLLA = getSubdomain();
    const serverEndpoint = getServerEndpoint(COLLA);
    const endpoint = type === 'svg' ? 'export_svg' : 'download_plantilla';
    const ext = type === 'svg' ? '.svg' : '.aleta';
    const url = `${serverEndpoint}/api/${endpoint}/${plantilla}`;

    fetch(url, {
        method: 'GET',
        headers: { 'x-api-key': '453dabb4-7645-4626-a1bb-477dff3aa557' }
    })
    .then(response => response.blob())
    .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = `${COLLA}-${plantilla}${ext}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    });
};
